<template>
    <div>
        <popup title="LAUNCH PATIENT PASS" v-if="openPopup" @close="hidePopup()" @on-cancel-click="hidePopup()"
        @on-save-click="okBtnClick()"
        :displayPopup="openPopup" :showAddNewBtn="false" :showSaveBtn="showOKBtn" saveBtnTxt="OK" size="sm" >
            <div id="popupContent" style="height: 345px; overflow: auto; margin-bottom: 30px;"> 
                <b-container class="h-100">
                    <b-row class="h-100">
                        <b-col class="col-10">
                            <b-row class="h-100 w-75">
                                <b-col v-if="isTarPassEnabled" class="col-11 mt-3 mb-1 text-light">
                                    <b-form-checkbox
                                        size="sm"
                                        id="chkTxPass"
                                        v-model="isTarPass"
                                        name="chkTxPass"
                                        :value="true"
                                        :unchecked-value="false">
                                        Access TXPass
                                    </b-form-checkbox>
                                </b-col>
                                <b-col class="col-11 my-1">
                                    <b-form-datepicker size="sm" :hide-header="true" v-model="fromDate" :min="minDate"></b-form-datepicker>
                                </b-col>
                                <b-col class="col-10 my-1">
                                    <select v-model="selectedTime" class="custom-select custom-select-sm">
                                        <option :value="null" disabled>-- Please select a pass --</option>
                                        <option v-for="option in times" v-bind:value="option.Value" :key="option.Key">
                                            {{ option.Key }}
                                        </option>
                                    </select>
                                </b-col>
                                <!--<b-col v-if="useNewMedpass" class="col-11 my-1 text-light">
                                    <b-form-checkbox
                                        size="sm"
                                        id="chkUseOldMedpass"
                                        v-model="useOldMedpass"
                                        name="chkUseOldMedpass"
                                        :value="true"
                                        :unchecked-value="false">
                                        Use Old Medpass
                                    </b-form-checkbox>
                                </b-col>-->
                                <b-col class="col-12 text-light">
                                    Please Select a Pass Date and Time from the boxes on the left and click ok to launch Pass.
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </popup>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "launch-patient-pass-popup",
        props: {
         },
        data: function () {
            return {
                facilityID: null,
                fromDate: null,
                isTarPass: false,
                isTarPassEnabled: false,
                openPopup: false,
                patientID: null,
                selectedTime: null,
                showOKBtn: false,
                times: [],
                useNewMedpass: false,
                useOldMedpass: false,
                minDate: null
            };
        },
        watch: {
            selectedTime: function(newVal){
                var vm = this;
                if(newVal)
                    vm.showOKBtn = true;
                else
                    vm.showOKBtn = false;
            },
            fromDate: function(){
                var vm = this;
                vm.getMedPassTimes();
            },
            isTarPass: function(){
                var vm = this;
                vm.getMedPassTimes();
            }
        },
        methods: {
            init: function () {
                var vm = this;
                var t = new Date();
                vm.fromDate = t.getFullYear() + '-' + (t.getMonth()+1) + '-' + t.getDate();
                vm.minDate = t;
                vm.minDate.setDate(vm.minDate.getDate() - 30);
                vm.getLaunchPatientPassPopupVM();
                vm.getMedPassTimes();
            },
            showPopup: function() {
                var vm = this;
                vm.openPopup = true;
                vm.init();
            },
            hidePopup: function() {
                this.openPopup = false;
            },
            loadPass: function() {
                var vm = this;
                if(vm.useOldMedpass){
                    var url = 'StartMedpass.aspx?mp=' + vm.selectedTime;
                    if (this.isTarPass) {
                        url += "&tar=true";
                    }
                    url += "&id=" + vm.patientID;
                    window.open(url, "_blank", "height=900,width=1060,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,tollbar=0");
                }else{
                    vm.generateOTP(function(otp){
                        var isTarPassQryStr = '';
                        if (vm.isTarPass) {
                            isTarPassQryStr = "&i=true";
                        }
                        window.location.href = 'sapphiremedpass://app/params/?&o=' + otp + '&u=' + vm.userID + '&p=' + vm.patientID + '&f=' + vm.facilityID + '&t=' + vm.selectedTime + isTarPassQryStr + '&source=' + window.location.host;
                    });
                }
                return true;
            },
            okBtnClick: function() {
                var vm = this;
                if(vm.loadPass())
                    vm.hidePopup();
            },
            getLaunchPatientPassPopupVM: function(){
                var vm = this;
                axios.post("../../Common/Services/EmarClientOperations.svc/GetLaunchPatientPassPopupVM",
                {
                    facilityID: vm.facilityID
                })
                    .then((response) => {
                        var d = JSON.parse(response.data.d);
                        vm.useNewMedpass = d.UseNewMedpass;
                        vm.isTarPassEnabled = d.IsTarPassEnabled;
                        vm.userID = d.UserID;
                        vm.useOldMedpass = !vm.useNewMedpass;
                });
            },
            getMedPassTimes: function (){
                var vm = this;
                axios.post("../../Common/Services/EmarClientOperations.svc/GetMedPassTimes",
                {
                    facilityID: vm.facilityID,
                    patientID: vm.patientID,
                    fromDate: vm.fromDate,
                    isTarPass: vm.isTarPass
                })
                    .then((response) => {
                        vm.selectedTime = null;
                        vm.times = JSON.parse(response.data.d);
                });
            },
            generateOTP: function (cb){
                axios.post("../../Common/Services/EmarClientOperations.svc/generateOTP")
                    .then((response) => {
                        var otp = JSON.parse(response.data.d);
                        cb(otp);
                });
            }
        }
    }
</script>